import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "latest-movie-favorites";

function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favoriteIds, setFavoriteIds] = useState<string[]>([]);

  useEffect(() => {
    setFavoriteIds(readFavorites());
  }, []);

  const persist = useCallback((ids: string[]) => {
    setFavoriteIds(ids);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch {
      // ignore storage quota errors
    }
  }, []);

  const isFavorite = useCallback((id: string) => favoriteIds.includes(id), [favoriteIds]);

  const toggleFavorite = useCallback(
    (id: string) => {
      const current = readFavorites();
      const next = current.includes(id)
        ? current.filter((x) => x !== id)
        : [...current, id];
      persist(next);
      return next.includes(id);
    },
    [persist]
  );

  return { favoriteIds, isFavorite, toggleFavorite };
}